export default "__VITE_ASSET__dXnEXh9u__"